import {Component, Renderer2} from '@angular/core';
import {ToastService} from "../../../../core/services/toast.service";
import {ActivatedRoute, Router} from "@angular/router";
import {CommonService} from "../../../../core/services/common.service";
import {combineLatest as observableCombineLatest,  Observable } from 'rxjs';
import {HttpClientService} from "../../../../core/services/http-client.service";
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent {
  customer;
  customerId: any = 0;
  public loading: boolean = false;
  public user: any = {};
  otpRequested = true;
  visible: any;
  public otpValue: string = null;
  public verify: any = {};
  verified: boolean=false;
  otpSend: boolean=false;
  showNewPassword: boolean = false;
  showConfirmPassword: boolean = false;
  constructor(
    private toast: ToastService,
    private route: ActivatedRoute,
    private _router: Router,
    public common: CommonService,
    private renderer: Renderer2,
    private http: HttpClientService,
  ){}

  ngOnInit() {

    observableCombineLatest([
      this.route.data,
      this.route.queryParams,
      this.route.params,
    ]).subscribe((bothParams) => {
      //Category id is unused for now
      console.log(bothParams);

      this.customerId = +bothParams[1].customerId;

      this.getCustomerById(this.customerId)
        .subscribe(data => {
          this.loading = false;
          if (data['responseStatus'].toLowerCase() == 'success') {
            //If mobile number exists
            this.customer = data['response'];
            this.user.mobile = this.customer.mobileNumber

          }
        });
    });
  }
  public usersignIn(params): Observable<any> {
    return this.http.post(`store/signin`, params);
  };

  public getCustomerById(id: Number): Observable<any> {
    return this.http.get(`store/getCustomerById/${id}`);
  };
  signIn() {
    this.loading = true;
    this.usersignIn(this.user).subscribe(response => {
      this.loading = false;
      if (response.response) {
        this.common.setStorage('customer', this.customer);
        this.common.setLoggedIn(true);
        this.toast.success("You are successfully logged in");
        this._router.navigate([this.common.getNavigteUrl()]);
      } else {
        this.toast.error("Could not logged in, password invalid");
        this.renderer.selectRootElement('#password').focus();
      }
    },
      error => {
        this.loading = true;
        this.toast.error("Something went wrong")
      });
  }
  toggleNewPasswordVisibility() {
    this.showNewPassword = !this.showNewPassword;
  }

  toggleConfirmPasswordVisibility() {
    this.showConfirmPassword = !this.showConfirmPassword;
  }
  public generateOTP(params): Observable<any> {
    return this.http.get("store/otp/generateOTP", params);
  };
  public verifyuserOTP(params): Observable<any> {
    return this.http.get("otp/verifyOTP", params);
  };

  public requestOtp() {
    this.loading = true;
    delete this.user.password;
    this.generateOTP(this.user).subscribe(response => {
      this.otpRequested = false;
      this.otpSend=true
      this.loading = false;
      this.verify['mobile'] = String(this.user.mobile);
      this.verify['referenceId'] = response.response.reference_id;
    });
  }

  public verifyOtp() {
    this.verify['otpCode'] = this.otpValue;
    this.verifyuserOTP(this.common.stringParams(this.verify)).subscribe(response => {
      if (response.response.result) {
        this.otpSend=false;
        this.verified=true;
      }
    });
  }
  back() {
    window.history.back();
  }


  goToPage(url): void {
    url = `/${url}`;
    this._router.navigateByUrl(url + "?customerId=" + this.customer.id);

  }
  register() {
    this._router.navigate(['/auth']);
  }
  public resetuserPassword(params) {
    return this.http.post("store/resetPassword", params);
  }
  resetPassword() {
    // Validate if passwords match
    if (this.user.password !== this.user.confirmPassword) {
      this.toast.error("Passwords do not match");
      return;
    }

    // Validate password length and strength
    if (this.user.password.length < 8) {
      this.toast.error("Password length should be at least 8 characters");
      return;
    }

    // Add other validations if required (e.g., include uppercase, lowercase, numbers)
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/;
    if (!passwordRegex.test(this.user.password)) {
      this.toast.error(
        "Password must include at least one lowercase letter, one uppercase letter, and one number"
      );
      return;
    }

    // If validations pass, make the reset password API call
    this.loading = true; // Set loading state
    this.resetuserPassword(this.user).subscribe(
      (response) => {
        this.loading = false;
        if (response?.responseStatus?.toLowerCase() === "success") {
          this.toast.success("Password reset successful");
          this.common.setStorage("customer", this.customer);
          this.common.setLoggedIn(true);
          this.visible=false;
          this._router.navigate(['/login'], { queryParams: { customerId: this.customer.id } });

        } else {
          this.toast.error("Failed to reset password. Please try again.");
        }
      },
      (error) => {
        this.loading = false;
        this.toast.error("An error occurred while resetting the password");
      }
    );
  }


}
